/**
 * Borrower-facing compliance language for V1 flows.
 */

export const V1_DISCLAIMERS = {
  global: 'LoanKnow helps you organize information for lenders. Nothing here is a loan approval, credit decision, or rate lock.',
  estimates: 'Payment, DTI, and LTV figures are estimates based on what you entered. Lenders and investors may use different guidelines.',
  productChoice: 'You choose which loan packet to prepare. LoanKnow does not recommend one lender or one loan product over another.',
  triage: 'These questions help us show which preparation paths may be relevant—not whether you are approved.',
};

export const V1_BANNED_UI_TERMS = [
  'recommend',
  'best match',
  'pre-approved',
  'preapproved',
  'you qualify',
  'you are eligible',
  'denied',
  'not eligible',
];

export const V1_LABELS = {
  fileCompleteness: 'File completeness',
  preparationScore: 'Preparation score',
  explorePacket: 'Prepare this packet',
  comparePackets: 'You may want to explore both paths',
  selectedPacket: 'Your selected packet',
};
